function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var defaultHeaders = {
  Accept: 'application/hal+json,application/json;q=0.9',
  'Content-Type': 'application/json'
};
function setHeaders(_ref) {
  var jwtToken = _ref.jwtToken,
    nonce = _ref.nonce,
    orgContext = _ref.orgContext,
    loginContext = _ref.loginContext;
  Object.assign(defaultHeaders, jwtToken && {
    Authorization: "bearer ".concat(jwtToken)
  }, nonce && {
    'DM-NONCE': nonce
  }, loginContext && {
    'DM-LOGIN-CONTEXT': loginContext
  }, orgContext && {
    'DM-ORG-CONTEXT': orgContext
  });
}

/**
 *
 * @param options {HttpOptions}
 * @param options.omit {RequestInit} pass in an object mirroring the RequestInit
 *   object if you want to delete any options (e.g., Content-Type header)
 * @example
 * http.getOptions({
 *   omit: {
 *     headers: {
 *       'Content-Type': null // can by any value
 *     }
 *   }
 * })
 */
function getOptions() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$omit = options.omit,
    omit = _options$omit === void 0 ? {} : _options$omit,
    httpOpts = _objectWithoutProperties(options, ["omit"]);
  var opts = Object.assign({}, httpOpts, {
    headers: Object.assign({}, defaultHeaders, httpOpts.headers)
  });
  if (Object.keys(omit).length) {
    return omitThings(omit, opts);
  } else {
    return opts;
  }
}
function omitThings(omit) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return Object.keys(options).reduce(function (acc, next) {
    // @ts-ignore
    var key = omit[next];
    var prop = omit.hasOwnProperty(next);
    if (prop && !isObject(key)) {
      // do nothing
    } else if (prop) {
      // @ts-ignore
      acc[next] = omitThings(key, options[next]);
    } else {
      // @ts-ignore
      acc[next] = options[next];
    }
    return acc;
  }, {});
}
function isObject(obj) {
  return obj !== null && typeof obj === 'object' && !Array.isArray(obj);
}
export default {
  setHeaders: setHeaders,
  getOptions: getOptions
};